module.exports = __webpack_public_path__ + "img/default-patient.e14e0574.png";